import React from 'react';
import {
  Paper,
  Typography,
  Divider,
  Stack,
  useTheme,
  Link,
  Grid,
} from '@mui/material';

import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmailIcon from '@mui/icons-material/Email';
import PhoneEnabledIcon from '@mui/icons-material/PhoneEnabled';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const SubsidiaryCard = ({ sucursal = {}, onSelect, name, index }) => {
  const theme = useTheme();

  if (!sucursal?.name) return null;

  const handleWhatsAppClick = e => {
    e.stopPropagation();
    const cleanNumber = sucursal?.whatsapp?.replace(/\s+/g, '');
    if (cleanNumber) window.open(`https://wa.me/${cleanNumber}`, '_blank');
  };

  return (
    <Paper
      key={`paper-suc-${index}`}
      onClick={() => onSelect(sucursal)}
      elevation={0}
      sx={{
        borderRadius: 2,
        cursor: 'pointer',
        '&:hover': { backgroundColor: '#F6F6F6' },
        transition: 'background-color 0.2s ease',
        color: '#000',
        '& .MuiTypography-root': { color: '#000' },
        pl: 2,
      }}
    >
      <Stack>
        {/* Nombre */}
        <Stack direction="row" alignItems="center">
          <LocationOnIcon sx={{ fontSize: 24, color: theme.primary }} />
          <Typography variant="subtitle1" fontWeight={700}>
            {sucursal.name?.replace(name + '- ', '')}
          </Typography>
        </Stack>

        {/* Dirección */}
        <Typography sx={{ fontSize: 18 }}>{sucursal.address}</Typography>
        <Typography sx={{ fontSize: 16 }}>Leg. {sucursal.file}</Typography>

        {/* Email */}
        {sucursal.email && (
          <Stack direction="row" alignItems="center" spacing={1}>
            <EmailIcon sx={{ fontSize: 22 }} />
            <Link
              href={`mailto:${sucursal.email}`}
              underline="hover"
              sx={{
                fontSize: 16,
                color: 'blue !important',
                fontFamily: 'Open Sans,sans-serif',
                lineHeight: '16px',
                display: 'flex',
                alignItems: 'center',
              }}
              onClick={e => e.stopPropagation()}
            >
              {sucursal.email}
            </Link>
          </Stack>
        )}

        {/* Teléfono y WhatsApp al final */}
        <Grid container sx={{ ml: 0, mr: 0, mt: 1, mb: 1 }}>
          {/* WhatsApp */}
          {sucursal.whatsapp && (
            <Grid
              item
              xs={6}
              display="flex"
              alignItems="center"
              sx={{ cursor: 'pointer' }}
              onClick={handleWhatsAppClick}
            >
              <WhatsAppIcon sx={{ fontSize: 22, color: '#63cb77', mr: 1 }} />
              <Typography sx={{ fontSize: 16 }}>{sucursal.whatsapp}</Typography>
            </Grid>
          )}

          {/* Teléfono */}
          {sucursal.phone && (
            <Grid
              item
              xs={6}
              display="flex"
              alignItems="center"
              justifyContent="start"
            >
              <PhoneEnabledIcon sx={{ fontSize: 22, mr: 1 }} />
              <Typography sx={{ fontSize: 16 }}>{sucursal.phone}</Typography>
            </Grid>
          )}
        </Grid>

        <Divider sx={{ opacity: 0.5, mt: '4px', mb: '4px' }} />
      </Stack>
    </Paper>
  );
};

export default SubsidiaryCard;
